import React from "react";

function Footer() {
  return (
    <div className="jumbotron footer" style={{ margin: 0, borderTop: "1px solid #dedede" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="legal">
              <a
                href="https://www.westnat.com/legal-and-compliance/company-registration-details/"
                target="_blank"
                rel="noreferrer"
              >
                Legal Details
              </a>
              &nbsp;|&nbsp;
              <a
                href="https://www.westnat.com/legal-and-compliance/protection-of-personal-information/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </div>
            <div className="copyright">Western National ©{new Date().getFullYear()}</div>
            <div className="copyright">v2.0</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
